<!-- 账户流水 -->
<template>
  <div class="view-container">
    <!-- 筛选头部 -->
    <div class="sizer-view" v-if="sizerOpne == 0" @click="sizerOpne = 1">
      <div>筛选</div>
      <img src="@/assets/image/shaixuan.png" alt="" />
    </div>
    <!-- 筛选内容 -->
    <div class="sizer-content" v-else>
      <div class="flex-column-item" style="margin-top: 20px">
        <el-date-picker
          style="flex: 1"
          v-model="form.value1"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="center"
        >
        </el-date-picker>
        <el-input
          v-model="form.orderNo"
          placeholder="请输入订单号查询"
          style="flex: 1; margin: 0px 10px"
        ></el-input>
        <div style="width: 500px">
          <el-select
            v-model="form.type"
            placeholder="类型(全部)"
            style="width: 100%"
          >
            <el-option key="1" label="单卡提交" value="1"> </el-option>
            <el-option key="2" label="批量提交" value="2"> </el-option>
            <el-option key="3" label="提现" value="3"> </el-option>
            <el-option key="4" label="提现退单" value="4"> </el-option>
            <el-option key="5" label="加款" value="5"> </el-option>
            <el-option key="6" label="扣款" value="6"> </el-option>
            <el-option key="6" label="佣金" value="7"> </el-option>
          </el-select>
        </div>
      </div>
      <div class="flex-column-item" style="margin-top: 20px">
        <div style="flex: 1">
          <el-select
            v-model="form.direction"
            placeholder="状态(全部)"
            style="width: 100%"
          >
            <el-option key="1" label="增加金额" value="1"> </el-option>
            <el-option key="2" label="减少金额" value="2"> </el-option>
          </el-select>
        </div>
        <div style="margin: 0px 40px; flex: 1"></div>
        <div class="fold-view" style="flex: 1">
          <el-button @click="resetForm" style="width: 100px;">重置</el-button>
          <el-button type="primary" @click="fundRecord()" style="width: 100px;">查询</el-button>
          
          <!-- <div
            @click="sizerOpne = 0"
            style="padding: 0px 10px; font-size: 16px; color: #488eff"
          >
            收起
          </div> -->
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <div class="tab-view">
      <el-table
        :data="tableData"
        style="width: 100%"
        max-height="500"
        :header-cell-style="{
          backgroundColor: ' rgb(235, 237, 244)',
          color: 'black',
          fontSize: '14px',
          fontWeight: '600',
        }"
      >
        <el-table-column
          fixed
          prop="createTime"
          label="提交时间"
          min-width="150"
          max-width="150"
        >
        </el-table-column>
        <el-table-column
          prop="orderNo"
          label="订单号"
          min-width="150"
          max-width="150"
        >
        </el-table-column>
        <el-table-column
          prop="batchNo"
          label="批量订单号"
          min-width="150"
          max-width="150"
        >
        </el-table-column>
        <el-table-column
          prop="actionType"
          label="类型"
          min-width="150"
          max-width="150"
        >
        </el-table-column>
        <el-table-column
          prop="changeAmount"
          label="变动金额"
          min-width="150"
          max-width="150"
        >
        </el-table-column>
        <el-table-column
          prop="beforeBalance"
          label="变动前金额"
          min-width="150"
          max-width="150"
        >
        </el-table-column>
        <el-table-column
          prop="afterBalance"
          label="变动后金额"
          min-width="150"
          max-width="150"
        >
        </el-table-column>
        <el-table-column
          prop="notes"
          label="备注"
          min-width="150"
          max-width="150"
        >
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="scope" fixed>
            <el-button size="mini" type="text" @click="handleUpdate(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div
      style="
        margin-top: 30px;
        display: flex;
        justify-content: flex-end;
        padding-right: 30px;
      "
    >
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="form.pageNum"
        :limit.sync="form.pageSize"
        @pagination="fundRecord()"
      />
    </div>
    <!-- 流水详情-->
    <el-dialog
      title="流水详情"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
    >
      <el-form :model="formInline" label-width="120px" class="detail-form">
        <el-form-item label="提交时间">
          <el-input v-model="formInline.createTime" disabled></el-input>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="formInline.orderNo" disabled></el-input>
        </el-form-item>
        <el-form-item label="批量订单号">
          <el-input v-model="formInline.batchNo" disabled></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-input v-model="formInline.actionType" disabled></el-input>
        </el-form-item>
        <el-form-item label="变动金额">
          <el-input v-model="formInline.changeAmount" disabled></el-input>
        </el-form-item>
        <el-form-item label="变动前金额">
          <el-input v-model="formInline.beforeBalance" disabled></el-input>
        </el-form-item>
        <el-form-item label="变动后金额">
          <el-input v-model="formInline.afterBalance" disabled></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="formInline.notes" disabled></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import http from "@/utils/http/axios";
export default {
  data() {
    return {
      dialogVisible: false,
      total: 0,
      sizerOpne: 1,
      pickerOptions: {
        shortcuts: [
          {
            text: "本月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setDate(1);
              end.setMonth(end.getMonth() + 1);
              end.setDate(0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "今年至今",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      form: {
        value1: null,
        orderNo: "",
        type: "",
        direction: "",
        pageNum: 1,
        pageSize: 10,
      },
      currentPage4: 4,
      tableData: [],
      formInline: {},
    };
  },
  methods: {
    // 查看详情
    handleUpdate(row) {
      this.dialogVisible = true;
      this.formInline = { ...row };
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.formInline = {};
    },
    // 添加重置方法
    resetForm() {
      // 重置表单数据
      this.form = {
        value1: null,
        orderNo: "",
        type: "",
        direction: "",
        pageNum: 1,
        pageSize: 10,
      };
      // 重置后自动查询
      this.fundRecord();
    },
    // 账号流水接口
    fundRecord() {
      if (this.form.value1) {
        const startDate = this.formatDate(this.form.value1[0]);
        const endDate = this.formatDate(this.form.value1[1]);
        this.form.endDate = endDate;
        this.form.startDate = startDate;
        delete this.form.value1;
      }
      http
        .get(
          `/user/fund/record${(() => {
            const params = Object.keys(this.form)
              .filter(
                (key) =>
                  this.form[key] !== undefined &&
                  this.form[key] !== null &&
                  this.form[key] !== ""
              )
              .map(
                (key) =>
                  `${encodeURIComponent(key)}=${encodeURIComponent(
                    this.form[key]
                  )}`
              )
              .join("&");
            return params ? `?${params}` : "";
          })()}`
        )
        .then((response) => {
          if (response.code === 200) {
            this.total = response.total;
            this.tableData = response.rows.map((row) => ({
              ...row,
              createTime: this.convertDate(row.createTime),
              auditTime: this.convertDate(row.auditTime),
              updateTime: this.convertDate(row.updateTime),
            }));
          }
        })
        .catch((error) => {
          console.error("Error fetching fund record:", error); // 添加详细错误日志
          this.$message.error("发生意外异常");
        });
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    convertDate(isoDateString) {
      const date = new Date(isoDateString);
      return this.formatDate(date);
    },
  },
};
</script>

<style lang="less" scoped>
.sizer-view {
  padding: 0px 30rpx;
  display: flex;
  align-items: center;
  font-size: 16px;
  height: 80px;
  color: #488eff;
  font-weight: 600;
  background-color: white;
  padding-left: 30px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;

  img {
    width: 24px;
    height: 24px;
    margin-left: 10px;
  }
}

.sizer-content {
  height: 150px;
  background-color: white;
  padding: 0px 30px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  .flex-column();

  .flex-column-item {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .fold-view {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}

.view-container {
  background-color: white;
  height: 100%;

  .tab-view {
    border: 2px solid #ebeef5;
    margin: 0px 30px;
    border-radius: 5px;
  }
}

.detail-form {
  max-height: 60vh;
  overflow-y: auto;
  padding: 0 20px;

  /deep/ .el-form-item {
    margin-bottom: 18px;

    .el-input.is-disabled .el-input__inner {
      color: #606266;
      background-color: #f5f7fa;
    }
  }
}

.el-dialog {
  /deep/ .el-dialog__body {
    padding: 10px 0;
  }
}
</style>